/**
 *
 * CreateTax
 *
 */
import { memo } from 'react';

import { useTranslation } from 'react-i18next';

import { ReportForm } from '../../components/ReportForm';

// eslint-disable-next-line react/display-name
export const CreateReport = memo(() => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { t, i18n } = useTranslation();

  return (
    <div>
      <ReportForm defaultValue={{}} />
    </div>
  );
});
